import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import TrailSwipeTransition  from "../game/crazy/TrailSwipeTransition";

const emojis = ["🧑‍🚀", "⛵", "🦄", "🐘", "🧜", "🐬"];

// Floating particles configuration
const createParticle = () => ({
  id: Math.random(),
  emoji: ['✨', '💎', '⭐', '🌟', '💫', '🔮'][Math.floor(Math.random() * 6)],
  x: Math.random() * 100,
  y: Math.random() * 100,
  size: Math.random() * 0.8 + 0.5,
  duration: Math.random() * 10 + 15,
  delay: Math.random() * 5
});

export default function Home() {
  const [name, setName] = useState("");
  const [selected, setSelected] = useState(emojis[0]);
  const levels = ["easy", "medium", "hard"]; 
  const [difficulty, setDifficulty] = useState("medium");
  const [particles, setParticles] = useState([]);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const navigate = useNavigate();
  const [showTransition, setShowTransition] = useState(false);
  const avatar = "🧑‍🚀"; // pull from context or selection if needed

  

  // Initialize particles and form animation
  useEffect(() => {
    // Create initial particles
    const initialParticles = Array.from({ length: 6 }, createParticle);
    setParticles(initialParticles);
    
    // Animate form entrance
    setTimeout(() => setIsFormVisible(true), 500);

    // ✅ DON'T load saved data - Always start fresh when coming to home
    // Clear any existing game data when user returns to home
    localStorage.removeItem("maze-player-name");
    localStorage.removeItem("adventure-name");
    localStorage.removeItem("player-name");
    localStorage.removeItem("maze-player-emoji");
    localStorage.removeItem("player-avatar");
    localStorage.removeItem("player-emoji");
    localStorage.removeItem("maze-difficulty");
    
    
  }, []);

  // ✅ Regenerate particles periodically (existing functionality)
  useEffect(() => {
    const interval = setInterval(() => {
      setParticles(prev => {
        const newParticles = prev.filter(p => Date.now() - p.id < p.duration * 1000);
        if (newParticles.length < 6) {
          newParticles.push(createParticle());
        }
        return newParticles;
      });
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const startGame = () => {
    // ✅ Enhanced data saving - Store with multiple keys for compatibility
    const playerName = name || "Explorer";
    const playerEmoji = selected;
    const gameDifficulty = difficulty;
     

    // Save with all possible key variations for maximum compatibility
    localStorage.setItem("maze-player-name", playerName);
    localStorage.setItem("maze-player-emoji", playerEmoji);
    localStorage.setItem("maze-difficulty", gameDifficulty);
    
    // Additional keys for backward compatibility
    localStorage.setItem("adventure-name", playerName);
    localStorage.setItem("player-name", playerName);
    localStorage.setItem("player-avatar", playerEmoji);
    localStorage.setItem("player-emoji", playerEmoji);
    
    // 🎯 NEW: Auto-set maze settings based on difficulty
  const difficultySettings = {
    easy: { rows: 15, columns: 15, entries: "top and bottom", bias: "none" },
    medium: { rows: 21, columns: 21, entries: "top and bottom", bias: "none" },
    hard: { rows: 31, columns: 31, entries: "top and bottom", bias: "none" }
  };
  
  const mazeSettings = difficultySettings[gameDifficulty] || difficultySettings.medium;
  localStorage.setItem("maze-settings", JSON.stringify(mazeSettings));
  
  
  
  setShowTransition(true);
};
const handleTransitionComplete = () => {
  navigate("/play");
};


  const customStyles = `
    @keyframes float {
      0%, 100% { transform: translateY(0px); }
      50% { transform: translateY(-10px); }
    }
    
    @keyframes drift {
      0%, 100% { transform: translateX(0px); }
      50% { transform: translateX(20px); }
    }
    
    @keyframes fade-in {
      from { opacity: 0; }
      to { opacity: 1; }
    }
    
    @keyframes gentle-glow {
      0%, 100% { box-shadow: 0 0 10px rgba(251, 191, 36, 0.3); }
      50% { box-shadow: 0 0 15px rgba(251, 191, 36, 0.5); }
    }
    
    @keyframes particle-float {
      0%, 100% { transform: translateY(0px) rotate(0deg); }
      25% { transform: translateY(-15px) rotate(90deg); }
      50% { transform: translateY(-10px) rotate(180deg); }
      75% { transform: translateY(-20px) rotate(270deg); }
    }
    
    .animate-float { animation: float 6s ease-in-out infinite; }
    .animate-drift { animation: drift 20s ease-in-out infinite; }
    .animate-fade-in { animation: fade-in 0.8s ease-out; }
    .animate-gentle-glow { animation: gentle-glow 3s ease-in-out infinite; }
    .animate-particle-float { animation: particle-float 8s ease-in-out infinite; }
  `;

  return (
    <div className="min-h-screen w-full relative overflow-y-auto">

      {/* Inject custom styles */}
      <style dangerouslySetInnerHTML={{ __html: customStyles }} />
      {/* Top-left logo button */}
<div
  className="absolute top-4 left-4 z-50 cursor-pointer"
  onClick={() => navigate("/")}
  title="Return to Home"
>
  <img src="/M-logo.png" alt="MazeMoh Logo" className="w-10 h-10" />
</div>

      
      {/* Adventure Landscape Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-lime-100 via-green-200 to-emerald-100">


        {/* Sky Layer */}
        <div className="absolute inset-0 bg-gradient-to-b from-indigo-900 via-purple-800 to-pink-600"></div>
        
        {/* Mountain Layers */}
        <div className="fixed bottom-0 left-0 right-0 z-0 pointer-events-none">
          {/* Far Mountains */}
          <svg className="absolute bottom-0 w-full h-64" viewBox="0 0 1200 200" preserveAspectRatio="none">
            <path d="M0,200 L0,100 Q200,60 400,80 Q600,50 800,90 Q1000,40 1200,70 L1200,200 Z" 
                  fill="rgba(253, 186, 116, 0.15)"filter="blur(0.5px)"/>
          </svg>
          
          {/* Middle Mountains */}
          <svg className="absolute bottom-0 w-full h-48" viewBox="0 0 1200 150" preserveAspectRatio="none">
            <path d="M0,150 L0,80 Q150,40 300,60 Q450,30 600,70 Q750,20 900,50 Q1050,40 1200,60 L1200,150 Z" 
                  fill="rgba(253, 186, 116, 0.15)"/>
          </svg>
          
          {/* Front Hills */}
          <svg className="absolute bottom-0 w-full h-32" viewBox="0 0 1200 100" preserveAspectRatio="none">
            <path d="M0,100 L0,60 Q100,20 200,40 Q300,10 400,50 Q500,30 600,45 Q700,25 800,40 Q900,20 1000,35 Q1100,25 1200,40 L1200,100 Z" 
                  fill="#fb7185"
  style={{ filter: "drop-shadow(0 -2px 3px rgba(0,0,0,0.1))" }}
/>
          </svg>
        </div>

        {/* ✅ Enhanced Floating Particles with better animations */}
        {particles.map((particle, index) => (
          <div
            key={particle.id}
            className="absolute pointer-events-none select-none animate-particle-float"
            style={{
              left: particle.x + '%',
              top: particle.y + '%',
              fontSize: (particle.size * 1.2) + 'rem',
              animationDelay: particle.delay + 's',
              animationDuration: (particle.duration / 2) + 's',
              opacity: 0.7 + (particle.size * 0.3),
              zIndex: 5
            }}
          >
            {particle.emoji}
          </div>
        ))}

        {/* Subtle Clouds with gentle movement */}
        <div className="absolute top-8 left-10 text-white text-3xl opacity-80 animate-drift">
          ☁️
        </div>
        <div className="absolute top-12 right-16 text-white text-2xl opacity-60 animate-drift" 
             style={{ animationDelay: '2s' }}>
          ☁️
        </div>
        <div className="absolute top-20 left-1/2 text-white text-xl opacity-70 animate-drift"
             style={{ animationDelay: '4s' }}>
          ☁️
        </div>
      </div>

      {/* Main Content */}
      <div className="relative z-10 h-full w-full flex items-center justify-center p-4 lg:p-8">
        <div className="w-full h-full max-w-6xl grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          
          {/* Left Side - Clean Title Section */}
          <div className="text-center lg:text-left space-y-6">
            <div className="space-y-4">
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white drop-shadow-lg">
                Welcome to
              </h1>
              <div className="text-5xl sm:text-6xl lg:text-7xl font-extrabold">
                <span className="bg-gradient-to-r from-yellow-300 via-orange-400 to-red-400 bg-clip-text text-transparent drop-shadow-sm">
                  MazeMoh
                </span>
              </div>
              <p className="text-xl sm:text-2xl text-white/90 font-medium drop-shadow">
                Lose yourself in mazes. Find your way to Moh.
              </p>
            </div>

            {/* Simple Maze Preview */}
            <div className="hidden lg:block mt-8">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 hover:bg-white/15 transition-all duration-300">
                <div className="grid grid-cols-8 gap-1 max-w-xs mx-auto mb-4">
                  {Array.from({length: 64}, (_, i) => {
                    const isPath = Math.random() > 0.6;
                    const isSpecial = Math.random() > 0.95;
                    return (
                      <div 
                        key={i} 
                        className={`w-6 h-6 rounded-sm transition-colors duration-300 ${
                          isSpecial ? 'bg-teal-300 animate-gentle-glow' :
                          isPath ? 'bg-amber-500' : 'bg-pink-200/40'
                        }`}
                      />
                    );
                  })}
                </div>
                <p className="text-white/80 text-sm text-center">
                  🎯 Every turn is a choice. Every gem, a moment of joy. Every wall, a test of patience. In the end — love awaits.
                </p>
                <div className="mt-3 flex justify-center space-x-2">
                  <span className="text-xs bg-white/20 px-2 py-1 rounded-full">🏃‍♀️ Move</span>
                  <span className="text-xs bg-white/20 px-2 py-1 rounded-full">💎 Collect</span>
                  <span className="text-xs bg-white/20 px-2 py-1 rounded-full">🏆 Win</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Clean Game Setup Panel */}
          <div className={'w-full max-w-md mx-auto lg:mx-0 transition-all duration-1000 ' + (
  isFormVisible ? 'translate-x-0 opacity-100' : 'translate-x-8 opacity-0'
)}>
  <div className="bg-white/95 backdrop-blur-sm rounded-3xl shadow-2xl p-6 lg:p-8 border border-white/30 max-h-[85vh] overflow-y-auto">

              
              {/* Name Input */}
              <div className="space-y-4">
                <div>
                  <label className="block text-lg font-semibold text-gray-700 mb-2">
                    🌟 Adventure Name
                  </label>
                  <input
                    placeholder="Enter your explorer name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    maxLength={15}
                    className="w-full border-2 border-pink-200 px-4 py-3 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all hover:shadow-md"
                  />
                  {name.length === 15 && (
    <p className="mt-2 text-sm text-green-600 animate-fade-in">
      Max 15 characters reached. Make it short and cute
    </p>
  )}
                  {name && (
                    <div className="mt-2 text-sm text-green-600 animate-fade-in">
                      ✨ Welcome, brave {name}!
                    </div>
                  )}
                </div>

                {/* Clean Difficulty Selection */}
                <div>
                  <label className="block text-lg font-semibold text-gray-700 mb-3">
                    🎯 Choose Your Challenge
                  </label>
                  <div className="grid grid-cols-3 gap-2">
                    {levels.map((lvl) => {
  const isMobile = window.innerWidth < 640;
  const shouldShow = lvl === "easy" || !isMobile;

  return shouldShow ? (
    <button
      key={lvl}
      onClick={() => setDifficulty(lvl)}
      className={
        'capitalize px-4 py-3 rounded-xl font-medium transition-all duration-300 ' +
        (difficulty === lvl
          ? "bg-violet-500 text-white shadow-lg transform scale-105"
          : "bg-violet-100 text-violet-800 hover:bg-violet-200 hover:scale-102")
      }
    >
      <div className="flex flex-col items-center space-y-1">
        <span>{lvl}</span>
        <div className="text-xs opacity-75">
          {lvl === 'easy' ? '🌱' : lvl === 'medium' ? '⚡' : '🔥'}
        </div>
      </div>
    </button>
  ) : null;
})}

                  </div>
                  <div className="mt-2 text-xs text-gray-500 text-center">
                    {difficulty === 'easy' && "🌱 Perfect for beginners"}
                    {difficulty === 'medium' && "⚡ Balanced challenge"}
                    {difficulty === 'hard' && "🔥 For maze masters"}
                  </div>
                </div>

                {/* Clean Avatar Selection */}
                <div>
                  <label className="block text-lg font-semibold text-gray-700 mb-3">
                    🎭 Choose Your Avatar
                  </label>
                  <div className="grid grid-cols-3 gap-3">
                    {emojis.map((emoji) => (
                      <button
                        key={emoji}
                        onClick={() => setSelected(emoji)}
                        className={'text-4xl p-4 rounded-xl transition-all duration-300 ' + (
                          selected === emoji
                            ? "bg-pink-100 ring-4 ring-pink-300 transform scale-110 shadow-md"
                            : "bg-white hover::bg-pink-50 hover:scale-105"
                        )}
                      >
                        {emoji}
                      </button>
                    ))}
                  </div>
                  <div className="mt-2 text-center">
                    <span className="text-2xl">{selected}</span>
                    <span className="ml-2 text-sm text-gray-600">Ready for adventure!</span>
                  </div>
                </div>

                {/* Simple Start Game Button */}
                <div className="w-full">
  <button
        onClick={startGame}
        className="w-full bg-gradient-to-r from-orange-400 to-red-500 text-white font-semibold py-3 px-6 rounded-xl shadow-lg
                   hover:scale-[1.03] transition-all duration-300 ease-in-out transform flex items-center justify-center gap-2"
      >
        🚀 Step Into the Maze of Moh ✨
      </button>

      {showTransition && (
  <TrailSwipeTransition emoji={selected} onComplete={handleTransitionComplete} />
)}

    </div>


                
                {/* Simple Progress indicator */}
                <div className="mt-4 flex justify-center space-x-2">
                  <div className={'w-2 h-2 rounded-full transition-colors duration-500 ' + (name ? 'bg-green-500' : 'bg-gray-300')}></div>
                  <div className={'w-2 h-2 rounded-full transition-colors duration-500 ' + (difficulty ? 'bg-green-500' : 'bg-gray-300')}></div>
                  <div className={'w-2 h-2 rounded-full transition-colors duration-500 ' + (selected ? 'bg-green-500' : 'bg-gray-300')}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}